import * as React from "react";

function ArrowRightGreenSvg(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.43 5.93L20.5 12l-6.07 6.07"
        stroke="url(#paint0_linear_1071_14937)"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 12h16.83"
        stroke="url(#paint1_linear_1071_14937)"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1071_14937"
          x1={17.4647}
          y1={5.93018}
          x2={17.4647}
          y2={18.0702}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#099D16" />
          <stop offset={1} stopColor="#006209" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1071_14937"
          x1={11.915}
          y1={12}
          x2={11.915}
          y2={13}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#099D16" />
          <stop offset={1} stopColor="#006209" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default ArrowRightGreenSvg;
